import script from "./UploadSignFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadSignFile.vue?vue&type=script&setup=true&lang=ts"

import "./UploadSignFile.vue?vue&type=style&index=0&id=fc2fdd5e&scoped=true&lang=css"

import exportComponent from "K:\\VoionContaract\\voion.contaract.clients\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc2fdd5e"]])

export default __exports__